@if (segmentedButtons || languages) {
  <div class="segmented-btn-container">
    @if (type === 'view-switcher') {
      @for (button of segmentedButtons; track trackByFn($index, button)) {
        @if (button.isAvailable) {
          <rt-segmented-control-button
            [type]="type"
            [isActive]="button.isActive"
            [isDisabled]="isDisabled || button.isDisabled"
            [isAvailable]="button.isAvailable"
            [label]="button.label"
            [counter]="button.counter"
            [iconName]="button.iconName"
            [isUnread]="button.isUnread"
            [fullwidth]="fullwidth"
            [suffixTpl]="button.suffixTpl || null"
            (click)="segmentedButtonClicked.emit(button.value)"
          ></rt-segmented-control-button>
        }
      }
    }
    @if (type === 'multilang-switcher') {
      @for (language of languages; track trackByLangCode($index, language)) {
        <rt-segmented-control-button
          [type]="type"
          [language]="language"
          [isActive]="language.code === activeLanguage"
          [isDisabled]="isDisabled"
          [isAvailable]="isAvailable"
          [loadingLanguageCode]="loadingLanguageCode"
          [fieldsCount]="fieldsCount"
          [fullwidth]="fullwidth"
          (click)="segmentedButtonClicked.emit(language)"
        ></rt-segmented-control-button>
      }
    }
  </div>
}
